import { z } from 'zod';

import { OpportunitySchema } from './opportunity';
import { ZodCandidateOpportunityCandidateStatuses } from './candidate-opportunities-candidate-statuses';

export const OpportunityReduxSchema = OpportunitySchema.extend({
  opportunityId: z.string().uuid(),
  candidateStatus: ZodCandidateOpportunityCandidateStatuses.nullable(),
});

export type OpportunityRedux = z.infer<typeof OpportunityReduxSchema>;
